import { ActionControlSize } from "@1js/acui-common";

/** Set of icons that may be used to represent a ribbon control */
export interface RibbonIconSet {
  /** This is the default icon ID to be used with the ribbon control
   * This icon is typically 20x20
   */
  default: string;

  /** ID of 16x16 icon to be used  */
  icon16?: string;

  /** ID of 32x32 icon to be used  */
  icon32?: string;
}

/**
 * Gets a an icon id from the iconSet that is based on the control size
 * @param iconSet The set of icons for the control
 * @param controlSize The size of the control being rendered
 * Default:  If there is no icon size passed in we will return size 20 (mostly used with SLR)
 */
export function getIconBasedOnSize(
  iconSet?: RibbonIconSet,
  controlSize?: ActionControlSize
) {
  if (!iconSet) return undefined;

  let icon: string | undefined = undefined;
  switch (controlSize) {
    case ActionControlSize.Small: {
      icon = iconSet.icon16;
      break;
    }
    case ActionControlSize.Large: {
      icon = iconSet.icon32;
      break;
    }
  }

  return icon || iconSet.default;
}
